import { render, staticRenderFns } from "./QaListItemSkeletonLoader.vue?vue&type=template&id=9e874ce2&scoped=true&"
import script from "./QaListItemSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./QaListItemSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemSkeletonLoader.vue?vue&type=style&index=0&id=9e874ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e874ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
